import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Formik, Field } from "formik";
import { TextField } from "formik-material-ui";
import { Cancel } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import {
  Grid,
  FormControl,
  Select,
  InputLabel,
  Chip,
  TextField as TextFieldMaterial,
} from "@material-ui/core";
import { Page, Button, LoadMask, DialogModal } from "../../../../components";
import { Colors } from "../../../../constants";
import { RoutePaths } from "../../../../constants/RoutePaths";
import { Mask } from "../../../../utils";
import { typeTag } from "./constants";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import isEqual from "lodash.isequal";

const PageActionButton = styled(Button).attrs(({ variant }) => ({
  size: "large",
  color: "secondary",
  variant: variant || "contained",
}))`
  margin-left: 24px;
`;

const SectionWrapper = styled.div`
  display: flex;
  margin-bottom: 48px;
`;

const SectionTitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 270px;
  margin-right: 24px;
`;

const SectionTitleLabel = styled.div`
  width: 240px;
  font-size: 24px;
  text-align: left;
  color: ${Colors.SECONDARY_MEDIUM};
`;

const CardSection = styled.div`
  flex: 1;
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid ${Colors.GRAY_LIGHT};
  box-sizing: border-box;

  ${({ flexColumn }) =>
    flexColumn &&
    `
    flex-direction: column;
  `}
`;

const CardContent = styled.div`
  width: 100%;
  padding: 24px;

  ${({ block }) =>
    block &&
    `
    flex: 1;
  `}

  ${({ blueBg }) =>
    blueBg &&
    `
    background-color: ${Colors.Alpha(Colors.PRIMARY_BLUE, 0.04)};
  `}
`;

const StyledField = styled(Field)`
  width: 100%;
`;

const Divider = styled.div`
  width: 100%;
  height: 24px;
`;

const ActionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const FormControlStyled = styled(FormControl)`
  width: 100%;
`;

const SelectStyled = styled(Select)`
  & > div > span {
    display: none;
  }
`;

const DialogContent = styled.div`
  width: 600px;
  display: flex;
  align-items: center;
  padding: 16px 0;
`;

const WrapperField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BoldText = styled.span`
  font-weight: bold;
`;

const RowCategorie = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ChipStyled = styled(Chip)`
  font-size: 13px;
  font-weight: 400;
  margin-right: 8px;
`;

const CancelStyled = styled(Cancel)`
  width: 24px;
  height: 24px;

  color: ${Colors.SECONDARY_MEDIUM};

  &:hover {
    color: ${Colors.SECONDARY_MEDIUM};
  }
`;

const filter = createFilterOptions();

const FormAgentLayout = ({
  userData,
  title,
  loading,
  requestDialog,
  handleValidations,
  tagBusinessUnityList,
  tagLineList,
  tagGroupSectorList,
  tagSectorList,
  handleAgentSubmit,
  isEditing,
  agentDetailData,
  handleNewTag,
  newTag,
  handleZipCodeInfo,
  zipCodeInfo,
}) => {
  const [businessUnityField, setBusinessUnityField] = useState([]);
  const [isOpenTagModal, setIsOpenTagModal] = useState(false);
  const [dataBusinessUnityList, setDataBusinessUnityList] = useState([]);
  const [businessUnityListSelected, setBusinessUnityListSelected] = useState(
    agentDetailData?.data?.tags?.map((item) => item.id) ?? []
  );
  const [typeOfTag, setTypeOfTag] = useState("");
  const [typeOfTagText, setTypeOfTagText] = useState(1);
  const [agentTags, setAgentTags] = useState([]);
  const [isOpenAgentDialog, setIsOpenAgentDialog] = useState(false);
  const [isDisableSaveButton, setIsDisableSaveButton] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (tagBusinessUnityList.list.length) {
      setDataBusinessUnityList(
        tagBusinessUnityList.list.map((business) => ({
          id: business.id,
          name: business.name,
        }))
      );
    }
    if (agentDetailData.data) {
      const agentIdTags = agentDetailData.data
        ? agentDetailData.data.tags.map((item) => item.id)
        : [];
      setAgentTags(agentIdTags);

      if (tagBusinessUnityList.list.length) {
        const foundBusinessUnity = tagBusinessUnityList.list.filter(
          (item) => agentIdTags.indexOf(item.id) !== -1
        );
        if (Object.values(foundBusinessUnity).length) {
          setBusinessUnityField(foundBusinessUnity[0].id);
        }
      }
    }
  }, [agentDetailData, tagBusinessUnityList.list]);

  useEffect(() => {
    if (newTag.id) {
      if (typeOfTag === typeTag.BU.type) {
        updateTags(newTag.id, typeTag.BU.type);
        setDataBusinessUnityList((dataBusinessUnityList) => [
          { id: newTag.id, name: `${newTag.name}` },
          ...dataBusinessUnityList,
        ]);
        setBusinessUnityField(newTag.id);
      }
      setIsOpenTagModal(false);
    }
  }, [newTag.id]);

  const initialValues = {
    name:
      agentDetailData.data && agentDetailData.data.name
        ? agentDetailData.data.name
        : "",
    email:
      agentDetailData.data && agentDetailData.data.email
        ? agentDetailData.data.email
        : "",
    phone1:
      agentDetailData.data && agentDetailData.data.phone1
        ? Mask.tel(agentDetailData.data.phone1, "", true)
        : "",
    phone2:
      agentDetailData.data && agentDetailData.data.phone2
        ? Mask.tel(agentDetailData.data.phone2, "", true)
        : "",
    cep:
      agentDetailData.data && agentDetailData.data.cep
        ? Mask.cep(agentDetailData.data.cep, "", true)
        : "",
    street:
      agentDetailData.data && agentDetailData.data.street
        ? agentDetailData.data.street
        : "",
    number:
      agentDetailData.data && agentDetailData.data.number
        ? agentDetailData.data.number
        : "",
    neighborhood:
      agentDetailData.data && agentDetailData.data.neighborhood
        ? agentDetailData.data.neighborhood
        : "",
    addressDetail:
      agentDetailData.data && agentDetailData.data.addressDetail
        ? agentDetailData.data.addressDetail
        : "",
    city:
      agentDetailData.data && agentDetailData.data.city
        ? agentDetailData.data.city
        : "",
    uf:
      agentDetailData.data && agentDetailData.data.uf
        ? agentDetailData.data.uf
        : "",
    tags:
      agentDetailData.data && agentDetailData.data.tags
        ? agentDetailData.data.tags
        : [],
    newTag: "",
    taxNumber:
      agentDetailData.data && agentDetailData.data.taxNumber
        ? Mask.cpfCnpjInputMask(agentDetailData.data.taxNumber)
        : "",
  };

  const useStyles = makeStyles(
    {
      paper: {
        minWidth: "280px !important",
        maxHeight: 200,
      },
    },
    { name: "MuiPopover" }
  );

  const classes = useStyles();

  const setPhoneMask = (event, fieldName, setFieldValue) => {
    setFieldValue(fieldName, Mask.tel(event.target.value, null, true));
  };

  const setCepMask = (event, setFieldValue) => {
    setFieldValue("cep", Mask.cep(event.target.value, null, true));
    if (event.target.value.length === 9) {
      handleZipCodeInfo(event.target.value.replace("-", ""));
    }
  };

  const setCepData = (event, setFieldValue, validateForm) => {
    if (
      zipCodeInfo &&
      Object.values(zipCodeInfo).length &&
      zipCodeInfo.cep === event.target.value
    ) {
      setFieldValue("street", zipCodeInfo.street ? zipCodeInfo.street : "-");
      setFieldValue(
        "neighborhood",
        zipCodeInfo.neighborhood ? zipCodeInfo.neighborhood : "-"
      );
      setFieldValue(
        "addressDetail",
        zipCodeInfo.addressDetail ? zipCodeInfo.addressDetail : ""
      );
      setFieldValue("city", zipCodeInfo.city ? zipCodeInfo.city : "-");
      setFieldValue("uf", zipCodeInfo.uf ? zipCodeInfo.uf : "-");
      setTimeout(() => {
        validateForm();
      }, 500);
    } else {
      setFieldValue("cep", "");
      setFieldValue("street", "");
      setFieldValue("neighborhood", "");
      setFieldValue("addressDetail", "");
      setFieldValue("city", "");
      setFieldValue("uf", "");
    }
  };

  const _onOpenAgentDialog = () => {
    setIsOpenAgentDialog(true);
  };

  const _onCloseAgentDialog = () => {
    setIsOpenAgentDialog(false);
  };

  const updateTags = (tags) => {
    const newTags = tags.map((tag) => tag.id);
    setAgentTags(newTags);
  };

  const _handleAgentSubmit = (values) => {
    const filteredValues = values;
    if (filteredValues.taxNumber) {
      filteredValues.taxNumber = filteredValues.taxNumber.replace(/\D/g, "");
    }
    delete filteredValues.newTag;
    if (agentDetailData.data) {
      handleAgentSubmit(filteredValues, agentTags, agentDetailData.data.id);
    } else {
      handleAgentSubmit(filteredValues, agentTags);
    }
  };

  const fieldsHasChanged = (values) => {
    return isEqual(values, initialValues)
  };

  const isDisabledSaveButton = (touched, isValid) => {
    return (!isEditing && Object.values(touched).length === 0) || !isValid;
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={handleValidations}
      enableReinitialize
      className={classes.root}
    >
      {({ isValid, touched, values, setFieldValue, validateForm, errors }) => {
        return (
          <>
            <Page
              userData={userData}
              title={title}
              smallTitle
              originPath={RoutePaths.AGENT}
              originPathName="Representantes"
            >
              <Divider />
              <SectionWrapper>
                <SectionTitleContainer>
                  <SectionTitleLabel>Dados pessoais</SectionTitleLabel>
                </SectionTitleContainer>
                <CardSection>
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item lg={12} md={12} xs={12}>
                        <StyledField
                          name="name"
                          type="text"
                          label="Nome*"
                          variant="outlined"
                          component={TextField}
                        />
                      </Grid>
                    </Grid>
                    <Divider />
                    <Grid container spacing={3}>
                      <Grid item lg={3} md={3} xs={3}>
                        <StyledField
                          name="phone1"
                          type="tel"
                          label="Telefone*"
                          variant="outlined"
                          component={TextField}
                          onKeyUp={(event) => {
                            setPhoneMask(event, "phone1", setFieldValue);
                          }}
                        />
                      </Grid>
                      <Grid item lg={3} md={3} xs={3}>
                        <StyledField
                          name="phone2"
                          type="text"
                          label="Telefone 2 (opcional)"
                          variant="outlined"
                          component={TextField}
                          onKeyUp={(event) => {
                            setPhoneMask(event, "phone2", setFieldValue);
                          }}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} xs={6}>
                        <StyledField
                          name="email"
                          type="text"
                          label="E-mail*"
                          variant="outlined"
                          component={TextField}
                        />
                      </Grid>
                      <Grid item lg={12} md={12} xs={12}>
                        <StyledField
                          name="taxNumber"
                          type="text"
                          label="CPF ou CNPJ do representante*"
                          variant="outlined"
                          component={TextField}
                          onKeyUp={(event) => {
                            setFieldValue(
                              "taxNumber",
                              Mask.cpfCnpjInputMask(event.target.value)
                            );
                          }}
                          disabled={isEditing}
                        />
                      </Grid>
                    </Grid>
                    <Divider />
                    <Divider />
                    <Divider />
                    <Grid container spacing={3}>
                      <Grid item lg={3} md={3} xs={3}>
                        <StyledField
                          name="cep"
                          type="text"
                          label="CEP*"
                          variant="outlined"
                          component={TextField}
                          onKeyUp={(event) => {
                            setCepMask(event, setFieldValue);
                          }}
                          onBlur={(event) => {
                            setCepData(event, setFieldValue, validateForm);
                          }}
                        />
                      </Grid>
                      <Grid item lg={9} md={9} xs={9}>
                        <StyledField
                          name="street"
                          type="text"
                          label="Endereço*"
                          variant="outlined"
                          component={TextField}
                          disabled
                        />
                      </Grid>
                    </Grid>
                    <Divider />
                    <Grid container spacing={3}>
                      <Grid item lg={3} md={3} xs={3}>
                        <StyledField
                          name="number"
                          type="text"
                          label="Número*"
                          variant="outlined"
                          component={TextField}
                        />
                      </Grid>
                      <Grid item lg={4} md={4} xs={4}>
                        <StyledField
                          name="addressDetail"
                          type="text"
                          label="Complemento (opcional)"
                          variant="outlined"
                          component={TextField}
                        />
                      </Grid>
                      <Grid item lg={5} md={5} xs={5}>
                        <StyledField
                          name="neighborhood"
                          type="text"
                          label="Bairro*"
                          variant="outlined"
                          component={TextField}
                          disabled
                        />
                      </Grid>
                    </Grid>
                    <Divider />
                    <Grid container spacing={3}>
                      <Grid item lg={10} md={10} xs={10}>
                        <StyledField
                          name="city"
                          type="text"
                          label="Cidade*"
                          variant="outlined"
                          component={TextField}
                          disabled
                        />
                      </Grid>
                      <Grid item lg={2} md={2} xs={2}>
                        <StyledField
                          name="uf"
                          type="text"
                          label="Estado*"
                          variant="outlined"
                          component={TextField}
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </CardSection>
              </SectionWrapper>
              <SectionWrapper>
                <SectionTitleContainer>
                  <SectionTitleLabel>
                    Categorização do representante
                  </SectionTitleLabel>
                </SectionTitleContainer>
                <CardSection>
                  <CardContent>
                    <RowCategorie>
                      <FormControlStyled name="tags" variant="outlined">
                        <Autocomplete
                          selectOnFocus
                          clearOnBlur
                          handleHomeEndKeys
                          name="tags"
                          multiple
                          limitTags={4}
                          options={dataBusinessUnityList}
                          getOptionLabel={(option) => option.name}
                          filterOptions={(options, params) => {
                            const filtered = filter(options, params);

                            if (params.inputValue !== "") {
                              filtered.push({
                                id: "__create__",
                                name: `➕ Criar nova categoria "${params.inputValue}"`,
                                inputValue: params.inputValue,
                              });
                            }

                            return filtered;
                          }}
                          value={values.tags}
                          onChange={(event, newValue) => {
                            const createOption = newValue.find(
                              (item) => item.id === "__create__"
                            );

                            if (createOption) {
                              const cleaned = newValue.filter(
                                (item) => item.id !== "__create__"
                              );

                              setBusinessUnityListSelected(cleaned);
                              setFieldValue("newTag", createOption.inputValue);

                              setIsOpenTagModal(true);
                              return;
                            }

                            const tagsUpdated = newValue
                              .map(
                                (v) =>
                                  dataBusinessUnityList.find(
                                    (opt) => opt.id === v.id
                                  ) || v
                              )
                              .filter(
                                (v, i, arr) =>
                                  arr.findIndex((o) => o.id === v.id) === i
                              );

                            updateTags(tagsUpdated);
                            setFieldValue("tags", tagsUpdated);
                            setBusinessUnityListSelected(tagsUpdated);
                          }}
                          renderTags={(values, getTagProps) =>
                            values.map((option, index) => (
                              <ChipStyled
                                variant="default"
                                label={option.name}
                                deleteIcon={<CancelStyled />}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextFieldMaterial
                              {...params}
                              variant="outlined"
                              label="Selecionar categoria:"
                              placeholder="Selecionar categoria:"
                            />
                          )}
                        />
                      </FormControlStyled>
                    </RowCategorie>
                  </CardContent>
                </CardSection>
              </SectionWrapper>
              <ActionWrapper>
                <PageActionButton
                  variant="outlined"
                  type="button"
                  onClick={() => {
                    history.push(RoutePaths.AGENT);
                  }}
                >
                  Cancelar
                </PageActionButton>
                <PageActionButton
                  type="submit"
                  onClick={_onOpenAgentDialog}
                  disabled={
                    isDisabledSaveButton(touched, isValid) ||
                    fieldsHasChanged(values)
                  }
                >
                  Salvar
                </PageActionButton>
              </ActionWrapper>
              {loading ||
              agentDetailData.loading ||
              tagBusinessUnityList.loading ||
              tagLineList.loading ||
              tagGroupSectorList.loading ||
              tagSectorList.loading ? (
                <LoadMask />
              ) : null}
              <DialogModal
                title="Salvar"
                size="xs"
                description={`Tem certeza que deseja salvar as informações do representante? ${
                  agentDetailData.data && agentDetailData.data.name
                    ? agentDetailData.data.name
                    : null
                }`}
                cancelButtonText="Cancelar"
                confirmButtonText="Salvar"
                handleCloseDialog={_onCloseAgentDialog}
                handleConfirmDialog={() => _handleAgentSubmit(values)}
                isOpenDialog={isOpenAgentDialog}
                loadingDialog={requestDialog.loading}
              />
              <DialogModal
                title="Criar nova tag"
                confirmButtonText="Confirmar"
                handleCloseDialog={() => {
                  setIsOpenTagModal(false);
                }}
                handleConfirmDialog={() => {
                  handleNewTag(`${values.newTag}`, typeOfTagText);
                }}
                enableConfirm={values.newTag === "" ? false : true}
                isOpenDialog={isOpenTagModal}
                size="md"
              >
                <DialogContent>
                  <WrapperField>
                    <StyledField
                      name="newTag"
                      type="text"
                      label="Nome da categoria:"
                      variant="outlined"
                      component={TextField}
                    />
                  </WrapperField>
                </DialogContent>
              </DialogModal>
            </Page>
          </>
        );
      }}
    </Formik>
  );
};

FormAgentLayout.propTypes = {
  userData: PropTypes.object,
  loading: PropTypes.bool,
  requestDialog: PropTypes.object,
  title: PropTypes.string,
  handleAgentSubmit: PropTypes.func,
  isEditing: PropTypes.bool,
  agentDetailData: PropTypes.object,
  handleNewTag: PropTypes.func,
  newTag: PropTypes.object,
  handleZipCodeInfo: PropTypes.func,
  zipCodeInfo: PropTypes.object,
};

FormAgentLayout.defaultProps = {
  userData: {},
  loading: false,
  requestDialog: {},
  title: "",
  handleAgentSubmit: () => {},
  isEditing: false,
  agentDetailData: {},
  handleNewTag: () => {},
  newTag: {
    id: undefined,
    name: undefined,
  },
  handleZipCodeInfo: () => {},
  zipCodeInfo: {
    loading: false,
  },
};

export default FormAgentLayout;
